<div *ngIf="notificationsList?.length > 0">
  <section class="content scrolleable" style="width: 27vw; overflow-x: hidden;">
    <div class="card-item-notifications" *ngFor="let notification of notificationsList">
      <div class="row">
        <div class="col-10 row pointer" (click)="navigateToComponentByNotification(notification.notificationId)">
          <div class="col-2 d-flex align-items-center justify-content-center" style="text-align: center; align-content: center;">
              <img *ngIf="notification.notificationPhoto != undefined"
                class="img-fluid rounded-circle border border-dark border-2" style="width: 40px; height: 40px;"
                [src]="'data:image/png;base64,' + notification.notificationPhoto" />
              <span style="font-size: medium;" *ngIf="notification.notificationPhoto == undefined"><i class="fa fa-bell" aria-hidden="true"></i></span>
          </div>
          <div class="col-10">
            <div class="col-12">
              <strong>{{ notification.fullName }}</strong>
            </div>
            <div class="col-12 d-flex align-items-center">
              <p class="mb-0 flex-shrink-0">{{ timeSince(notification.notificationSent) }}</p>
              <p class="mb-0 ml-2 flex-grow-1 text-truncate">
                {{ notification.templateName | localize }}
                <span *ngIf="notification.templateName === 'UploadFile'">
                  - {{ notification.fileName }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-2">
          <div class="w-100" style="text-align: right;">
            <div class="tooltip-wrapper">
              <i class="far fa-bell-slash pointer mr-2 option-item"
                 (mouseenter)="showTooltip(notification.notificationId)"
                 (mouseleave)="hideTooltip(notification.notificationId)"
                 (click)="setNotificationAsRead(notification.notificationId)">
              </i>
              <span class="custom-tooltip"
                    [class.visible]="tooltipsVisible[notification.notificationId]">
                {{ 'MarkAsRead' | localize }}
              </span>
            </div>
            <!--<i class="fas fa-inbox pointer mr-2 option-item" *ngIf="isDropdownOpen(notification.notificationId)"
              [tooltip]="'MarkAsArchived' | localize"
              (click)="setNotificationAsArchived(notification.notificationId)"></i>
            <i class="fas fa-ellipsis pointer" (click)="toggleDropdown(notification.notificationId)"></i>-->
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="show-all-button">
    <p class="pointer" (click)="navigateToComponent()">{{ "ShowAllNotifications" | localize }}</p>
  </div>
</div>
<div *ngIf="notificationsList?.length == 0">
  <section class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 mt-1">
          <i class="far fa-bell-slash mr-2"></i>
          <span>{{ "DontHaveUnarchivedNotifications" | localize }}</span>
        </div>
      </div>
    </div>
  </section>
  <div class="show-all-button">
    <p class="pointer" (click)="navigateToComponent()">{{ "ShowAllNotifications" | localize }}</p>
  </div>
</div>